import { brandName } from './brand';

// Marka henüz bilinmiyorsa (ayarlar gelmedi, önbellek boş) şablon boşa çevrilir;
// "Site" gibi bir yer tutucu yazmak yanlış bir marka göstermek olurdu.
//
// Alan adı şablonları (Alan Adları → domain yönetimi): {{primary_domain}} ana
// domain, {{next_domain}} sıradaki aktif alternatif. Duyuru metni "Güncel
// adresimiz {{primary_domain}}, bir sonraki {{next_domain}}" diye yazılırsa
// domain geçişinde metni elle güncellemek gerekmez.
export const renderSettingText = (value, settings = {}) => {
  const domains = settings?.site_domains || {};
  return String(value || '')
    .replace(/\{\{\s*site_name\s*\}\}/gi, brandName(settings))
    .replace(/\{\{\s*primary_domain\s*\}\}/gi, domains.primary || '')
    .replace(/\{\{\s*next_domain\s*\}\}/gi, domains.next || '');
};
